<template>
    <div id="plans">

        <div class="hero">
            <iframe width="100%" height="530px" src="https://my.matterport.com/show/?m=CWRCZJD9jtm"
                    frameborder="0" allowfullscreen allow="vr"></iframe>
<!--            <iframe width="100%" height="530px"-->
<!--                    src="https://www.youtube.com/embed/t2WlwVffyK0?autoplay=1&controls=0&showinfo=0&autohide=1&loop=1&mute=1"-->
<!--                    frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>-->
        </div>

        <h1>Plans</h1>

        <!--<v-container fluid align-center justify-center wrap>-->
            <!--<v-layout row align-center justify-center wrap>-->
                <!--<v-flex id="city" class="selection" xs12 sm12 md2 lg2 xl2 offset-md1 offset-lg1 offset-xl1>-->
                    <!--<h2>City</h2>-->
                    <!--<ul style="list-style-type: none; border: none; overflow-style: unset; overflow-scrolling: auto; overflow: visible;">-->
                        <!--<li v-for="(city, i) in parseCities" :key="i">-->
                            <!--<v-checkbox color="black" @click="" :label="city" style="margin: 0; padding: 0;"></v-checkbox>-->
                        <!--</li>-->
                    <!--</ul>-->
                <!--</v-flex>-->


                <!--<v-flex class="search-communities-select selection" xs12 sm12 md2 lg2 xl2>-->
                    <!--<h2>Plan</h2> &lt;!&ndash;@change="showItems()"&ndash;&gt;-->
                    <!--<v-select :items="planNames" v-model="plans.selectedPlans" chips clearable-->
                              <!--max-height="400" persistent-hint auto deletable-chips multiple></v-select>-->
                <!--</v-flex>-->

                <!--<v-flex id="home-type" class="selection" xs12 sm12 md2 lg2 xl2>-->
                    <!--<h2>Home Type</h2>-->
                            <!--<v-checkbox color="black" v-model="plans.rambler" @click=""> Ranbler</v-checkbox>-->
                            <!--<v-checkbox color="black" v-model="plans.twostory"> Two Story</v-checkbox>-->
                <!--</v-flex>-->
            <!--</v-layout>-->
        <!--</v-container>-->

        <div id="plan_list">
            <div class="plan" v-for="(plan, i) in parsePlans" :key="i" v-if="plan.disabled === false">
                <router-link tag="img" :to="{ path: '/plans/' + plan.plan_name }"
                             :src="plan.thumbnail_src"></router-link>
                <div>
                    <router-link :to="{ path: '/plans/' + plan.plan_name }">{{ plan.title }}</router-link>
                    <p>Total Sq Ft: {{ plan.total_size }}</p>
                    <p>Bedrooms: {{ bedrooms(plan) }}</p>
                    <p>Bathrooms: {{ plan.bathrooms }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    const apiToken = require('../../../credentials').API_TOKEN;
    const urlPath = require('../../../credentials').URL_PATH;

    const plan_data = {
        plans: {
            plansVisible: false,
            planVideo: 't2WlwVffyK0',
            homePlanShowChip: false,
            homePlanChipList: [],
            plans: [],
            showPlans: [],
            selectedPlans: [],
            planFolder: 'https://elitecrafthomes.com/static_files/images/plans',
            selectedHomeTypes: [],
            selectedCities: [],
            communities: []
        }
    };

    export default {
        name: 'Plans',
        data() {
            return plan_data;
        },
        computed: {
            parsePlans() {
                return this.plans.plans;
            },

            planNames() {
                return [...new Set(this.plans.showPlans.map(plan => plan.title))]
            },
            player() {
                return this.$refs.youtube.player;
            },
            parseCities() {
                return [...new Set(this.plans.communities.map(comm => comm.disabled === false ? comm.location.city : null))]
            }
        },
        methods: {
            playing() {
            },
            playVideo() {
                this.player.playVideo();
            },
            bedrooms(plan) {
                return plan.bedrooms.toLocaleString().length === 2 ?
                    `${plan.bedrooms.toLocaleString()[0]}-${plan.bedrooms.toLocaleString()[1]}` : plan.bedrooms;
            },

            showItems() {
                let tempSelected = this.plans.selectedPlans;
                this.plans.showPlans = [];
                for (let i = 0; i < tempSelected.length; i++) {
                    if (tempSelected[i].toLowerCase().includes(this.plans.plans[i].title.toLowerCase())) {
                        this.plans.showPlans.push(this.plans.plans[i])
                    }
                }
            },

            showPlans() {
                this.plans.plansVisible = true;
            },

            addPlans(chip) {
                // add chips back to the plan list
                this.plans.homePlanSelectionList.push(chip);
                this.plans.homePlanSelectionList.sort();
            },

            getPlans() {
                axios.get(urlPath + 'plans/plans/', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Headers': 'true',
                        'Access-Control-Allow-Origin': '*',
                        'Authorization': `Token ${apiToken}`
                    }
                })
                    .then((res) => {
                        for (let i = 0; i < res.data.length; i++) {
                            this.plans.plans.push({
                                plan_name: res.data[i].plan_name,
                                total_size: res.data[i].total_size,
                                bedrooms: res.data[i].bedrooms,
                                bathrooms: res.data[i].bathrooms,
                                disabled: res.data[i].disabled,
                                thumbnail_src: res.data[i].thumbnail_src,
                                title: res.data[i].title
                            })
                        }
                        this.plans.showPlans = this.plans.plans;

                    }, (res) => {

                    })
            },

            loadCommunities() {
                axios.get(urlPath + 'communities/communities/', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Headers': 'true',
                        'Access-Control-Allow-Origin': '*',
                        'Authorization': `Token ${apiToken}`
                    }
                })
                    .then(res => {
                        this.plans.communities = res.data
                    })
            },

            search(items, value) {
                // Returns the index of the string you're searching for, supports unsorted arrays o(n) :(
                if (items.length > 0) {
                    for (let i = 0; i < items.length; i++) {
                        if (items[i] === value) {
                            return i;
                        }
                    }
                }
            },

            binary(items, value) {
                let startIndex = 0;
                let endIndex = items.length - 1;
                let middle = Math.floor((endIndex + startIndex) / 2);

                while (items[middle] !== value && startIndex < endIndex) {
                    if (value < items[middle]) {
                        endIndex = middle - 1;
                    } else if (value > items[middle]) {
                        startIndex = middle + 1;
                    }

                    middle = Math.floor((endIndex + startIndex) / 2);
                }

                return (items[middle] !== value) ? -1 : middle;
            },
            hydrateLocations() {

            }
        },
        created() {
            this.getPlans();
            this.loadCommunities();
        },
        beforeMount() {
            this.plans.plans = [];
        }
    }

</script>

<style lang="scss" scoped>
    @font-face {
        font-family: "LibreBaskerville Bold";
        src: url("https://elitecrafthomes.com/static_files/fonts/LibreBaskerville-Bold.ttf")
    }

    * {
        box-sizing: border-box;
    }

    #plans {
        background-color: white;

        span.chip {
            cursor: pointer;
            .chip__content {
                cursor: pointer;
            }

        }
    }

    h1 {
        margin: 50px 0 75px 0;
        text-align: center;
        font-size: 32px;
        font-family: 'LibreBaskerville Bold', 'Muli', 'Avenir Next', 'Helvetica Neue', serif;
    }

    /*h2 span {*/
    /*cursor: pointer;*/
    /*}*/

    select, label {
        margin: 10px 0;
        width: 100%;
        font-size: 18px;
    }

    select:focus {
        outline: none;
    }

    ul {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 298px;
        text-align: center;
        overflow-y: scroll;
        border: 1px solid silver;
        /*border-top: none;*/
    }

    ul li {
        padding: 10px 0;
        font-size: 18px;
        list-style: none;
    }

    ul li:hover {
        color: white;
        background-color: silver;
        cursor: pointer;
    }

    #selections {
        margin-bottom: 50px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-start;
    }

    #individualplans {
        width: 100%;
        max-width: inherit;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
    }

    #home-plan {
        h2 {
            margin-bottom: 0;
            cursor: pointer;
            span {
                cursor: pointer;
            }
        }
        .chip-x {
            width: 17px;
            height: 17px;
            background-color: #777;
            border-radius: 50%;
            margin-left: 5px;
            span {
                color: black;
                position: absolute;
                top: 49%;
                right: 16.5px;
                transform: translateY(-49%);
                -ms-transform: translateY(-49%);
                font-weight: bold;
                font-size: 1.2em;
            }
        }

    }




    .hero {
        width: 100%;
        height: 530px;
        display: flex;
        justify-content: center;
        align-items: center;

        font-family: "Tahu", cursive;

        background-color: silver;
        overflow: hidden;

        .youtube-player {
            height: 530px;
            min-height: 530px;
        }
    }

    .selection {
        margin: 0 20px;
        width: 248px;
        height: 298px;
    }

    .selection h2 {
        width: 100%;
        text-align: center;
        border-bottom: 3px solid #909090;
    }

    .leading-text {
        font-weight: bold;
        margin-bottom: 0;
    }



    @media screen and (max-width: 450px) {
        #plan_list {
            margin: 50px auto 75px auto;
            text-align: center;
            padding: 0 10px;
        }

        .hero {
            height: 430px;
            max-height: 430px;
            .youtube-player {
                height: 430px;
                max-height: 430px;
                min-height: 430px;
            }
        }

        .plan {
            position: relative;
            height: 150px;
            img {
                max-width: 167px;
                width: 167px;
                max-height: 152px;
                height: 152px;
                object-fit: fill;
            }
            div {
                position: absolute;
                width: 50vw;
                top: 50%;
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
                -ms-transform: translateY(-50%);
                -o-transform: translateY(-50%);
                transform: translateY(-50%);

                a:nth-of-type(1) {
                    font-weight: 600;
                    font-size: 20px;
                    text-decoration: none;
                    color: black;
                }
                p {
                    font-weight: 400;
                    padding: 0;
                    margin: 0;
                }
            }
        }

        .plan:nth-child(odd) {
            img {

                float: left;
            }

            div {
                padding-left: 20px;
                right: 0;
                text-align: left;
            }
        }

        .plan:nth-child(even) {
            img {
                position: absolute;
                right: 0;
            }
            div {
                text-align: right;
                padding-right: 20px;
                left: 0;
            }
        }
    }

    @media screen and (min-width: 451px) and (max-width: 1024px) {
        #plan_list {
            padding: 0 10px;
            margin: 0 auto 50px auto;
            text-align: center;
            max-width: 600px;
            width: 100%;

            .plan {
                position: relative;
                max-width: 255px;
                width: 255px;
                height: 285px;
                display: inline-block;
                text-align: center;
                img {
                    max-width: 255px;
                    width: 255px;
                    max-height: 167px;
                    height: 167px;
                    object-fit: fill;
                }
                div {
                    position: absolute;
                    width: 100%;
                    bottom: 0;
                    text-align: center;
                    margin: 0 auto;
                    a:nth-of-type(1) {
                        font-weight: 600;
                        font-size: 20px;
                        padding-bottom: 10px;
                        text-align: center;
                        text-decoration: none;
                        color: black;
                    }
                    p {
                        font-weight: 400;
                        padding: 0;
                        margin: 0;
                        text-align: center;
                    }
                }
            }
            .plan:nth-child(odd) {
                margin: 0 35px 35px 0;

            }

            .plan:nth-child(even) {
                margin: 0 0 35px 35px;
            }
        }


    }

    @media screen and (min-width: 1025px) {
        #plan_list {
            margin: 50px auto 75px auto;
            text-align: center;
            padding: 0 10px;
            max-width: 1200px;
            width: 100%;
            .plan {
                position: relative;
                max-width: 255px;
                width: 255px;
                height: 300px;
                display: inline-block;
                text-align: center;
                margin: 15px 10px 25px 10px;
                img {
                    max-width: 255px;
                    width: 255px;
                    max-height: 167px;
                    height: 167px;
                    object-fit: fill;
                    cursor: pointer;
                }
                div {
                    position: absolute;
                    width: 100%;
                    bottom: 0;
                    text-align: center;
                    margin: 0 auto;
                    a:nth-of-type(1) {
                        font-weight: 600;
                        font-size: 20px;
                        padding-bottom: 10px;
                        text-align: center;
                        text-decoration: none;
                        color: black;
                    }
                    p {
                        font-weight: 400;
                        padding: 0;
                        margin: 0;
                        text-align: center;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/plans/Plans.vue